import React, { createContext, useContext, useEffect, useState } from "react";
import { api, apiError } from "./api";

const AuthContext = createContext(null);

// "Perfil Suporte" = conta de suporte ao cliente (role `colaborador` na BD; alias `suporte`).
export const isSuporteRole = (role) => role === "suporte" || role === "colaborador";

export const AuthProvider = ({ children }) => {
    // null = a verificar; false = não autenticado; objecto = autenticado
    const [user, setUser] = useState(null);
    const [booting, setBooting] = useState(true);

    useEffect(() => {
        const token = localStorage.getItem("salvador_token");
        if (!token) {
            setUser(false);
            setBooting(false);
            return;
        }
        api.get("/auth/me")
            .then((r) => setUser(r.data))
            .catch(() => setUser(false))
            .finally(() => setBooting(false));
    }, []);

    const login = async (email, password) => {
        try {
            const { data } = await api.post("/auth/login", { email, password });
            localStorage.setItem("salvador_token", data.token);
            localStorage.setItem("salvador_user", JSON.stringify(data.user));
            setUser(data.user);
            return { ok: true, user: data.user };
        } catch (e) {
            return { ok: false, error: apiError(e) };
        }
    };

    const logout = async () => {
        try {
            await api.post("/auth/logout");
        } catch (_) {
            // não bloqueia o logout local mesmo se backend falhar
        }
        localStorage.removeItem("salvador_token");
        localStorage.removeItem("salvador_user");
        setUser(false);
    };

    // Heartbeat: enquanto user está logado, ping ao backend a cada 90s
    // para que o admin consiga ver tempo online actualizado.
    useEffect(() => {
        if (!user || !user.id) return;
        const ping = () => {
            api.post("/heartbeat").catch(() => {});
        };
        ping();
        const id = setInterval(ping, 90000);
        // Ping extra em mudança de visibilidade (volta a estar visível)
        const onVis = () => {
            if (document.visibilityState === "visible") ping();
        };
        document.addEventListener("visibilitychange", onVis);
        return () => {
            clearInterval(id);
            document.removeEventListener("visibilitychange", onVis);
        };
    }, [user]);

    // "Ver como colaborador" — só altera UI localmente, sem mexer no backend
    const switchRole = (role) => {
        if (!user) return;
        const next = { ...user, role, realRole: user.realRole || user.role };
        setUser(next);
    };

    return (
        <AuthContext.Provider value={{ user, login, logout, switchRole, booting }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);
